import { Component, OnInit, Injector } from '@angular/core';
import { Location } from 'app/core/interfaces/location';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { PractitionerScheduleRegistrationComponent } from '../registration/schedule-registration.component';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'page-schedule-procedure',
  templateUrl: './schedule-procedure.component.html',
  styleUrls: ['./schedule-procedure.component.scss'],
})
export class PractitionerScheduleProcedureComponent extends BaseComponent implements OnInit {
  public title = 'Agendar';
  public search = '';
  public procedures: Healthcareservice[] = [];
  public locations: Location[] = [];
  public get proceduresFilter(): Healthcareservice[] {
    const procedures = [...this.procedures];
    return procedures.filter((item: Healthcareservice) => this.search == '' || (item.name && item.name.indexOf(this.search) > -1));
  }
  public latLong: any[] = [];
  public nextLatLong: [number, number] = [0, 0];
  distance: number = 10000; // valor padrão do raio de distância

  public currentPage: number = 0;
  public itemsPerPage: number = 10;

  public get showMessage(): boolean {
    if (this.loading || this.latLong.length == 0 || (this.procedures.length == 0 && this.latLong.length != 0)) {
      return true;
    }
    return false;
  }

  public get message(): string {
    if (this.loading) {
      return 'Buscando Exames mais proximos...';
    }
    if (this.latLong.length == 0) {
      return 'Ative sua localização para buscar os exames mais proximos';
    }
    if (this.procedures.length == 0 && this.latLong.length != 0) {
      return 'Não foi retornado nenhum exame para o raio definido...';
    }
    return '';
  }

  constructor(private procedureService: ProcedureService, private locationService: OrganizationLocationService, private injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.latLong.length === 0 ? this.getCurrentPosition() : this.getProceduresNearest();
  }

  public get totalPages(): number {
    return Math.ceil(this.proceduresFilter.length / this.itemsPerPage);
  }

  public get paginatedProcedures(): Healthcareservice[] {
    const start = this.currentPage * this.itemsPerPage;
    return this.proceduresFilter.slice(start, start + this.itemsPerPage);
  }

  public nextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
    }
  }

  public previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  getProceduresNearest() {
    this.procedures = [];
    this.loading = true;

    let params = new HttpParams();

    const position = this.latLong.join(',');
    params = params.set('position', position);
    params = params.set('radiusInMeters', this.distance);

    this.procedureService.listNearest(params).subscribe({
      next: (healthcareservices: Healthcareservice[]) => {
        this.procedures = healthcareservices;

        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        console.log(error);
      },
    });
  }

  hasButton() {
    if (this.latLong.length == 0) {
      return 'col-xs-12 col-lg-8 margin';
    }
    return 'col-xs-12 ';
  }

  public async getCurrentPosition() {
    if (navigator.geolocation) {
      navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
        if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(
            (position: any) => {
              this.latLong = [position.coords.longitude, position.coords.latitude];
              this.getProceduresNearest();
              this.getLocations();
            },
            (error: any) => {
              this.handleLocationError(error);
            }
          );
        } else {
          console.log('Por favor, ative a permissão de localização nas configurações do dispositivo.');
        }
      });
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  }

  private handleLocationError(error: any) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.error('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        console.error('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        console.error('The request to get user location timed out.');
        break;
      default:
        console.error('An unknown error occurred.');
        break;
    }
  }

  async openComponentDialogScheduleRegistrationForm(procedure: any) {
    await this.getOrganizationLocation(procedure);
    const data = {
      title: 'Agendar Exame',
      param: {
        procedure: procedure,
        type: 'Exame',
        address: this.getAddress(procedure?.organization.organization_id),
        latLong: this.nextLatLong,
      },
    };

    this.dialog.openComponentDialog(PractitionerScheduleRegistrationComponent, data);
  }

  getOrganizationLocation(procedure: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const organizationId = procedure.organization.organization_id;

      this.locationService.showByOrganization(organizationId).subscribe({
        next: (resOrganizationLocation) => {
          this.nextLatLong = [resOrganizationLocation.position.latitude ?? 0, resOrganizationLocation.position.longitude ?? 0];
          resolve();
        },
        error: (err) => {
          console.log(err);
          reject(err);
        },
      });
    });
  }

  getProcedures() {
    this.procedureService.list().subscribe((healthcareservices: Healthcareservice[]) => {
      this.procedures = healthcareservices;
    });
  }

  getLocations() {
    this.locationService.listNew().subscribe({
      next: (locations: Location[]) => {
        this.locations = locations;
      },
      error: (err) => {
        console.log('erro', err);
      },
    });
  }

  getCity(organization_id: string) {
    const location = this.locations.find((location) => location.organization_id == organization_id);

    if (!location) return null;

    return `${location?.address.city} / ${location.address.state}`;
  }

  getAddress(organization_id: string) {
    const location = this.locations.find((location) => location.organization_id == organization_id);

    return location?.address;
  }

  getHospitalName(procedure: Healthcareservice) {
    if (procedure.organization) {
      return `<br>${procedure.organization.name}  `;
    }
    return '';
  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'km';
    }

    return `${value}`;
  }
}
